import React from 'react';

const Switcher = ({ isActive, onClick, title }) => {
  return (
    <div className={`checkbox-block ${isActive ? 'active' : ''}`} onClick={onClick} title={title}>
      <span className='checkbox-circle' />
    </div>
  );
};

export default Switcher;
